import { render } from "./page13.vue?vue&type=template&id=5bf88570&scoped=true"
import script from "./page13.vue?vue&type=script&lang=js"
export * from "./page13.vue?vue&type=script&lang=js"

import "./page13.vue?vue&type=style&index=0&id=5bf88570&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf88570"]])

export default __exports__